"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledCardHeading = exports.StyledCard = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../../shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledCard = _styledComponents.default.div.withConfig({
  displayName: "style__StyledCard",
  componentId: "sc-dl7x45-0"
})(["box-sizing:border-box;width:", ";height:", ";background:", ";border:2px solid transparent;border-radius:4px;padding:16px 30px 24px 30px;:focus{outline:none;border:2px solid ", ";}.tab-mb{margin-bottom:20px;font-size:", ";line-height:", ";letter-spacing:0.02em;}"], ({
  width
}) => width && width, ({
  height
}) => height ? height : 'auto', _shared.theme.palette.brand.primary.white, _shared.theme.palette.ui.cta.yellow, _shared.theme.typography.h6.fontSize, _shared.theme.typography.h6.lineHeight);

exports.StyledCard = StyledCard;

const StyledCardHeading = _styledComponents.default.div.withConfig({
  displayName: "style__StyledCardHeading",
  componentId: "sc-dl7x45-1"
})(["", ";color:", ";margin-bottom:16px;text-align:left;"], _shared.theme.typography.body, _shared.theme.palette.brand.primary.charcoal);

exports.StyledCardHeading = StyledCardHeading;